
export class TruckerConfirmParameters {
	locCode: string = '';
	periodStartDate: string = '';
	periodEndDate: string = '';
	filterByUserName: string = '';
	openStatusOnly: boolean = false;
}